import { Box, Link } from "@mui/material";
import { SUPPORT_WEBFORM_URL } from "@src/appV2/ContactCBHInfo/constants";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ReactNode } from "react";

import clipboardWordmark from "../../../../public/assets/clipboard-wordmark-brown.png";

interface MobileLoginLayoutProps {
  children: ReactNode;
}

export function MobileLoginLayout({ children }: MobileLoginLayoutProps) {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.baseDark",
        overflow: "auto",
        paddingX: 5,
        paddingTop: "max(24px, env(safe-area-inset-top))",
        paddingBottom: "max(24px, env(safe-area-inset-bottom))",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        component="img"
        src={clipboardWordmark}
        alt="Clipboard"
        sx={{ height: 70, width: "auto", marginBottom: 5 }}
      />

      {children}

      <Box
        sx={{
          position: "absolute",
          bottom: "max(20px, env(safe-area-inset-bottom))",
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 4,
          alignItems: "center",
          whiteSpace: "nowrap",
        }}
      >
        <Text variant="body2" sx={{ color: "base.muted" }}>
          {`Clipboard Health \u00A9${new Date().getFullYear()}`}
        </Text>
        <Link
          href={SUPPORT_WEBFORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ fontSize: "0.875rem", color: "primary.main" }}
        >
          Contact Us
        </Link>
      </Box>
    </Box>
  );
}
